<template>
  <div>
    <a-card size="small" title="通道管理">
        <a-button slot="extra" type="primary" @click="handleNew">新增</a-button>

        <searchE @handleSearch="handleSubmit"></searchE>

        <tableE ref="passwayTableID"></tableE>

    </a-card>

     
  </div>
</template>
<script>

import searchE from './search'
import tableE from './table'
export default {
    data() {
        return {
           
        };
    },
    methods: {
        handleSubmit(searchP){
            this.$refs.passwayTableID.handleSearch(searchP);
        },
        handleNew(){
            this.$router.push({
                path: "add_passway",
                query: {id:''}
            });
        }
    },
    components:{
        searchE,
        tableE
    },
    mounted(){

    }
};
</script>
<style scoped>

</style>
